export function formatarTipoCliente(tipo: string): string {
  if (tipo === 'F') {
    return 'PF';
  }
  if (tipo === 'J') {
    return 'PJ';
  }
  return tipo == null ? '' : String(tipo);
}

export function formatarDocumentoCliente(documento: string, tipo: string): string {
  if (documento == null) {
    return '';
  }
  const original = String(documento);
  const digitos = original.replace(/\D/g, '');
  if (!digitos) {
    return original;
  }
  if (tipo === 'F' && digitos.length <= 11) {
    const cpf = digitos.padStart(11, '0');
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (tipo === 'J' && digitos.length <= 14) {
    const cnpj = digitos.padStart(14, '0');
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return original;
}

export function formatarTotalGasto(valor: number): string {
  if (valor == null || typeof valor !== 'number' || isNaN(valor)) {
    return valor == null ? '' : String(valor);
  }
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
}
